export default __webpack_public_path__ + "static/media/up-sorting-grey.f6d5bf15.svg";